import React from 'react'
import logo from '../assets/logo.png'

const Header = (props) => {
  const {user} = props;

  return (
    <header className="header">
      <img className="header__logo" src={logo} alt="Care Culinair" />
      <div className="header__profile">
        {user.user_type == 2 && 
          <div className="header__profile__icon">{user.firstname.charAt(0)}</div>
        }
        {user.user_type == 2 && 
          <span className="header__profile__name">{user.firstname + " " + user.lastname}</span>
        }
      </div>
    </header>
  );
}

export default Header